import { HashRouter, Route, Routes } from "react-router-dom";
import { Login } from "./containers/LoginPage";
import RouteConstant from "./constants/routeConstants.json";
import { LoginSuccess } from "./containers/LoginSuccessPage/index";
import "./App.css";

function App() {
  return (
    <div>
      <HashRouter>
        <Routes>
          <Route path={RouteConstant.LOGIN} element={<Login />} />
          <Route
            path={RouteConstant.LOGIN_SUCCESS}
            element={<LoginSuccess />}
          />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
